/** TrustSection (#confiance) — only safeguards that exist in the product. */

import { Link } from 'react-router';

import { useT } from '@/i18n';
import { Icon, SectionHeading } from './shared';

const ITEMS = [
  { key: 'i1', icon: 'shield' },
  { key: 'i2', icon: 'users' },
  { key: 'i3', icon: 'search' },
  { key: 'i4', icon: 'bolt' },
  { key: 'i5', icon: 'check' },
] as const;

export function TrustSection() {
  const { t } = useT();
  return (
    <section id="confiance" className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <SectionHeading
        eyebrow={t('routes.landing.v2.trust.eyebrow')}
        title={t('routes.landing.v2.trust.title')}
        subtitle={t('routes.landing.v2.trust.subtitle')}
      />
      <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((it) => (
          <li key={it.key} className="rounded-token-lg border border-border bg-surface p-6 shadow-elevation-1">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-token bg-emerald-500/10 text-emerald-600 dark:text-emerald-300">
              <Icon name={it.icon} className="h-5 w-5" strokeWidth={1.9} />
            </span>
            <h3 className="mt-3 font-semibold text-foreground">{t(`routes.landing.v2.trust.${it.key}Title`)}</h3>
            <p className="mt-1 text-sm leading-relaxed text-muted">{t(`routes.landing.v2.trust.${it.key}Text`)}</p>
          </li>
        ))}
      </ul>
      <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium">
        <li><Link className="text-primary hover:underline" to="/confidentialite">{t('routes.landing.v2.trust.linkPrivacy')}</Link></li>
        <li><Link className="text-primary hover:underline" to="/conditions">{t('routes.landing.v2.trust.linkTerms')}</Link></li>
        <li><Link className="text-primary hover:underline" to="/data-deletion">{t('routes.landing.v2.trust.linkDeletion')}</Link></li>
      </ul>
    </section>
  );
}
